module.exports = __webpack_public_path__ + "static/media/electronics4.a850d092.jpg";